import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Back from "../../../common/assets/images/Back.svg";
import Close from "../../../common/assets/images/Close.svg";
import moment from "moment";
import {
  Grid,
  Card,
  CardContent,
  Button,
  DialogTitle,
  Alert,
  AlertTitle,
  Dialog,
  DialogContent,
  Snackbar,
  useMediaQuery
} from "@mui/material";
import "../../../dataEntry/styles/DataEntry.scss";
import { Box } from "@mui/system";
import { deleteAdmin } from "../../reducers/wardThunk";
import {
  setErrorMessage,
  setsuccessMessage,
} from "../../../dataEntry/reducers/patientDataThunk";
import { ToastContainer, toast } from "react-toastify";

import { getWardDetail, deleteWard } from "../../reducers/wardThunk";

const DeleteWard = (props) => {
  const patient = useSelector((state) => state.patient);
  const user = useSelector((state) => state.user);
  const dbbranchdata = useSelector((state) => state.dashboard);
  const hospital_id = user.userProfile.hospital_id;
  const hospitalBranchId = user.branchdata.branch_id;
  const isMobile = useMediaQuery('(max-width:768px)');
  const ward_id =
    props && props.SelectedWard
      ? props.SelectedWard.ward_id
      : props.SelectedWard.ward_id;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

  const closeDialog = (e) => {
    e.preventDefault();
    props.onClose();
  };
  useEffect(() => {
    if (patient.errorMessage) {
      setTimeout(() => {
        dispatch(setErrorMessage(""));
      }, 10000);
    }
  }, [patient.errorMessage]);

  useEffect(() => {
    if (patient.successMessage) {
      setTimeout(() => {
        dispatch(setsuccessMessage(""));
      }, 10000);
    }
  }, [patient.successMessage]);

  const deleteselrecord = (e) => {
    e.preventDefault();
    dispatch(deleteWard(ward_id))
      .unwrap()
      .then((resdata) => {
        const req = hospital_id;
        dispatch(getWardDetail(req));
        navigate("/admin");

        toast.success("Ward Deleted Successfully", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        //dispatch(setsuccessMessage(resdata.message));
      });
    props.onClose();
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Dialog
        fullWidth="70%"
        maxWidth={props.maxWidth}
        open={props.open}
        onClose={props.onClose}
        className={isMobile ? 'report-dialogMobile' : 'report-dialog'}
      >
        <DialogTitle
          style={{
            borderBottom: "0.8px solid #f0f1fc",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <Link
              to="/"
              className="FIle-left"
              onClick={closeDialog}
              style={{ marginRight: "20px" }}
            >
              <img
                src={Back}
                className="file-img-left"
                alt=""
                style={{ width: "12px" }}
              />
            </Link>
            <span>Delete Conformation</span>
          </div>
          <div>
            <Link to="/" className="FIle-right-extreme" onClick={closeDialog}>
              <img src={Close} alt="" />
            </Link>
          </div>
        </DialogTitle>
        <DialogContent>
          <Box>
            <form id="bmrn-form">
              <Card style={{ marginTop: 10 }} variant="none">
                <CardContent>
                  <Grid container>
                    <Grid item xs={12} sm={12}>
                      <Alert severity="error">
                        <AlertTitle>
                          Are you sure you want to delete selected ward
                        </AlertTitle>
                      </Alert>
                    </Grid>
                    <div className="formSection" 
                    style={{ display: "contents" }}>
                      <Grid container>
                        <Grid item xs={12} sm={4}>
                          <Button
                            variant="contained"
                            className="back"
                            onClick={closeDialog}
                          >
                            Back
                          </Button>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                          <Button
                            variant="contained"
                            className={isMobile ? 'mobilePurple' : 'purple-add'}
                            type="submit"
                            onClick={(e) => deleteselrecord(e, ward_id)}
                          >
                            <span>Delete</span>
                          </Button>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                </CardContent>
              </Card>
            </form>
          </Box>
        </DialogContent>
      </Dialog>

      {patient.errorMessage && (
        <Snackbar
          open={patient.errorMessage}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert severity="error" variant="filled">
            {patient.errorMessage}
          </Alert>
        </Snackbar>
      )}
      {patient.successMessage && (
        <Snackbar
          open={patient.successMessage}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert severity="success" variant="filled">
            {patient.successMessage}
          </Alert>
        </Snackbar>
      )}
    </React.Fragment>
  );
};
export default DeleteWard;
